// extracted by mini-css-extract-plugin
export default {"productName":"ProductName_productName__LfzO1","title":"ProductName_title__ACkov"};